import React from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useMobileContext } from '../../contexts/MobileContext';
import ScrollFadeWrapper from '../../components/ScrollFadeWrapper/ScrollFadeWrapper';
import PageShell from '../../components/Layout/PageShell';
import SeoTagsManager from '../../utils/SeoTagsManager';

import LaunchPadHeroDesktop from '../../components/HomePage/LaunchPad/LaunchPadHeroDesktopComponent';
import LaunchPadHeroMobile from '../../components/HomePage/LaunchPad/LaunchPadHeroMobileComponent';
import launchPadHeroData from '../../json/components/HomePages/ContactUs/launchPadHeroData.json';

import ExpertQuotesComponent from '../../components/HomePage/ExpertQuotes/ExpertQuotesComponent';
import ExpertQuotesMobileComponent from '../../components/HomePage/ExpertQuotes/ExpertQuotesMobileComponent';
import expertQuotesData from '../../json/components/HomePages/ContactUs/expertQuotesData.json';

import KeyPointVerticalNumericComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericComponent';
import KeyPointVerticalNumericFourMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericFourMobileComponent';
import keyPointVerticalNumericData from '../../json/components/HomePages/ContactUs/keyPointVerticalNumericData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsData from '../../json/components/HomePages/ContactUs/scrollingCardsData.json';

import ContactFormComponent from '../../components/HomePage/ContactForm/ContactFormComponent';
import ContactFormMobileComponent from '../../components/HomePage/ContactForm/ContactFormMobileComponent';

import FooterComponent from '../../components/HomePage/Footer/FooterComponent';
import FooterMobileComponent from '../../components/HomePage/Footer/FooterMobileComponent';

function ContactUs() {
  const isMobile = useMobileContext();
  const { pathname } = useLocation();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        pt: { xs: 2, sm: 2 },
        minHeight: '100vh',
        overflowX: 'clip',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: '#F3F6F6',
          zIndex: 0,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        {SeoTagsManager.render(pathname)}
        <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
          <ScrollFadeWrapper>
            {isMobile.isDesktop ? (
              <LaunchPadHeroDesktop
                title={launchPadHeroData.title}
                subtitle={launchPadHeroData.subtitle}
                ctaLabel={launchPadHeroData.ctaLabel}
                ctaRoute={launchPadHeroData.ctaRoute}
                imageSrc={launchPadHeroData.imageSrc}
                imageAlt={launchPadHeroData.imageAlt}
                features={launchPadHeroData.features}
                footnote={launchPadHeroData.footnote}
                footnoteAlign="left"
              />
            ) : (
              <LaunchPadHeroMobile
                title={launchPadHeroData.title}
                subtitle={launchPadHeroData.subtitle}
                ctaLabel={launchPadHeroData.ctaLabel}
                ctaRoute={launchPadHeroData.ctaRoute}
                imageSrc={launchPadHeroData.imageSrc}
                imageAlt={launchPadHeroData.imageAlt}
                features={launchPadHeroData.features}
                footnote={launchPadHeroData.footnote}
                footnoteAlign="center"
              />
            )}
          </ScrollFadeWrapper>

          <ScrollFadeWrapper>
            {isMobile.isDesktop ? (
              <ContactFormComponent />
            ) : (
              <ContactFormMobileComponent />
            )}
          </ScrollFadeWrapper>

          <ScrollFadeWrapper>
            {isMobile.isDesktop ? (
              <ExpertQuotesComponent expertData={expertQuotesData} />
            ) : (
              <ExpertQuotesMobileComponent expertData={expertQuotesData} />
            )}
          </ScrollFadeWrapper>

          <ScrollFadeWrapper>
            {isMobile.isDesktop ? (
              <KeyPointVerticalNumericComponent
                data={keyPointVerticalNumericData}
              />
            ) : (
              <KeyPointVerticalNumericFourMobileComponent
                data={keyPointVerticalNumericData}
              />
            )}
          </ScrollFadeWrapper>

          <ScrollFadeWrapper>
            {isMobile.isDesktop ? (
              <ScrollingCardsComponent data={scrollingCardsData} />
            ) : (
              <ScrollingCardsMobileComponent data={scrollingCardsData} />
            )}
          </ScrollFadeWrapper>
        </PageShell>

        <Box sx={{ mt: 'auto' }}>
          {isMobile.isDesktop ? <FooterComponent /> : <FooterMobileComponent />}
        </Box>
      </Box>
    </Box>
  );
}

export default ContactUs;
